

import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { Link } from "react-router-dom";
const Validated00 = () => {

  const [approvedList, setApprovedList] =
    useState([]);

  const [loading, setLoading] =
    useState(true);
  const [idSearch, setIdSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  //  const isAgent = user?.role === "agent";
   const canSeeCreatedBy = user?.role === "admin" || user?.role === "quality";
  // ================= FETCH APPROVED =================
  const getApprovedLeads = async () => {

    try {

      setLoading(true);

      const response =
        await axiosInstance.get("/leads");

      // ✅ FILTER APPROVED
      const approvedData =
        response.data.data.filter(
          (item) =>
            item.lead_disposition ===
            "Validate OO"
        );

      setApprovedList(approvedData);

    } catch (error) {

      console.log(error);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    getApprovedLeads();
  }, []);

  // ================= SEARCH FILTER =================
  const filteredApprovedList = approvedList.filter((item) => {
    const idTerm = idSearch.trim().toLowerCase();
    const phoneTerm = phoneSearch.trim().toLowerCase();

    const idOk = !idTerm || String(item.id).toLowerCase().includes(idTerm);
    const phoneOk = !phoneTerm || (item.business_phone || "").toLowerCase().includes(phoneTerm);

    return idOk && phoneOk;
  });

  const hasActiveSearch = idSearch.trim() || phoneSearch.trim();

  return (
    <div className="min-h-screen bg-gray-100 p-6">

      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-2xl p-6">

        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">

          <h2 className="text-2xl font-bold text-green-600">

            Approved Leads

          </h2>

          <span className="bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-medium">

            Total: {filteredApprovedList.length}

          </span>

        </div>

        {/* SEARCH BARS */}
        <div className="flex flex-wrap gap-3 mb-6">

          {/* ID Search */}
          <div className="relative w-full sm:w-56">
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
            </svg>
            <input
              type="text"
              value={idSearch}
              onChange={(e) => setIdSearch(e.target.value)}
              placeholder="Search by ID..."
              className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-gray-300 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-transparent transition"
            />
            {idSearch && (
              <button
                onClick={() => setIdSearch("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>

          {/* Phone Search */}
          <div className="relative w-full sm:w-56">
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
            </svg>
            <input
              type="text"
              value={phoneSearch}
              onChange={(e) => setPhoneSearch(e.target.value)}
              placeholder="Search by phone..."
              className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-gray-300 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-transparent transition"
            />
            {phoneSearch && (
              <button
                onClick={() => setPhoneSearch("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>

          {/* Clear both */}
          {hasActiveSearch && (
            <button
              onClick={() => { setIdSearch(""); setPhoneSearch(""); }}
              className="px-4 py-2.5 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-semibold transition"
            >
              Clear filters
            </button>
          )}
        </div>

        {/* LOADING */}
        {loading ? (

          <div className="text-center py-10">
            Loading...
          </div>

        ) : filteredApprovedList.length === 0 ? (

          <div className="text-center py-10 text-slate-500">

            {hasActiveSearch ? "No leads match your search" : "No Approved Leads"}

          </div>

        ) : (

          <div className="overflow-x-auto">

            <table className="w-full border-collapse">

              {/* HEADER */}
              <thead>

                <tr className="bg-green-50 text-left border-b">

                  <th className="p-4">
                    ID
                  </th>

                  <th className="p-4">
                    Business
                  </th>

                  <th className="p-4">
                    Contact
                  </th>

                  <th className="p-4">
                    Phone
                  </th>

                  {/* <th className="p-4">
                    Audio
                  </th> */}


<th className="p-4">
  Supply Details
</th>     

                  <th className="p-4">
                    Status
                  </th>
{canSeeCreatedBy && (
 <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Created By
                  </th>
)}
                  <th className="p-4">
                    Date
                  </th>

                </tr>

              </thead>

              {/* BODY */}
              <tbody>

                {filteredApprovedList.map((item) => (

                  <tr
                    key={item.id}
                    className="border-b hover:bg-gray-50"
                  >

                    {/* ID */}
                 
<td className="p-4">
  
    <Link
     to={`/validate-00-details/${item.id}`}
      className="text-blue-600 font-semibold hover:underline"
    >
      #{item.id}
    </Link>

</td>
                    {/* BUSINESS */}
                    <td className="p-4">

                      <div className="font-semibold">

                        {item.business_name}

                      </div>

                      <div className="text-xs text-slate-500">

                        {item.business_address}

                      </div>

                    </td>

                    {/* CONTACT */}
                    <td className="p-4">
                      {item.contact_name}
                    </td>

                    {/* PHONE */}
                    <td className="p-4">
                      {item.business_phone}
                    </td>

                    {/* AUDIO */}
                    {/* <td className="p-4">

                      {item.vox_file ? (

                        <audio
                          key={item.vox_file}
                          controls
                          preload="metadata"
                          className="w-52"
                        >

                          <source
                            src={`https://ratcrm.zentelex.com/uploads/${item.vox_file}?t=${Date.now()}`}
                            type="audio/mpeg"
                          />

                        </audio>

                      ) : (

                        <span className="text-slate-400">
                          No File
                        </span>

                      )}

                    </td> */}

                    {/* FEEDBACK */}
                   <td className="p-4">

  {item.validation_type === "elec" && (
    <span className="text-sm font-medium text-slate-700">
      MPAN: {item.mpan || "-"}
    </span>
  )}

  {item.validation_type === "gas" && (
    <span className="text-sm font-medium text-slate-700">
      MPRN: {item.mprn_no || "-"}
    </span>
  )}

  {item.validation_type === "both" && (
    <div className="flex flex-col text-sm text-slate-700">

      <span>
        MPAN: {item.mpan || "-"}
      </span>

      <span>
        MPRN: {item.mprn_no || "-"}
      </span>

    </div>
  )}

</td>

                    {/* STATUS */}
                    <td className="p-4">

                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">

                        {item.lead_disposition }

                      </span>

                    </td>
{canSeeCreatedBy && (
  <td className="px-5 py-4 text-slate-500">
    {item.created_by_name}
  </td>
)}
                    {/* DATE */}
                    <td className="p-4 text-sm text-slate-500">

                      {new Date(
                        item.created_at
                      ).toLocaleDateString()}

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}

      </div>

    </div>
  );
};

export default Validated00;